import { useTranslation } from 'react-i18next'

import { Alert, Text } from '@reveni-io/reveni-ui'

const ReexportedRowsAlert = ({ errorRows, email }) => {
  const { t } = useTranslation()

  return (
    <Alert type="info">
      {t('Las {{rows}} filas con errores se han reexportado a', { rows: errorRows })}{' '}
      <Text type="bodyMBold" tag="span">
        {email}
      </Text>{' '}
      {t('en un archivo listo para corregir y volver a subir.')}
    </Alert>
  )
}

export default ReexportedRowsAlert
